import FormattedMessage from 'I18n/components/FormattedMessage';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { NavMarker } from 'react-rhumb';
import { StorefrontCollectionCard } from '../components/cards/StorefrontCollectionCard';
import { HeaderView } from '../components/headers/HeaderView';
import { PageHeader } from '../components/headers/PageHeader';
import { useAppContext } from '../context/AppContext';
import { StorefrontPaginator } from '../navigation/components/StorefrontPaginator';
import { usePagination } from '../navigation/hooks/usePagination';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Featured() {
  const appContext = useAppContext();
  const {
    getDisplayedCollections,
    requestState: publishedAppCollectionsRequestState
  } = usePublishedCollections({
    appContext: appContext,
    offeringType: 'APP'
  });
  const collections = getDisplayedCollections();
  const {
    currentPage,
    paginatedItems: paginatedCollections,
    pageCount,
    needsPagination,
    handlePageChange
  } = usePagination({
    items: collections
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FEATURED_LOAD",
    children: /*#__PURE__*/_jsxs(DashboardPage, {
      headerComponent: /*#__PURE__*/_jsx(HeaderView, {}),
      children: [/*#__PURE__*/_jsx(PageHeader, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featured.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featured.description"
        })
      }), /*#__PURE__*/_jsx(LoadingWrapper, {
        requestStatus: publishedAppCollectionsRequestState,
        children: /*#__PURE__*/_jsx(CardGrid, {
          "data-test-id": "featured-grid",
          columns: 2,
          gap: "400",
          children: paginatedCollections.map(collection => {
            var _collection$published, _collection$published2, _collection$published3;
            return /*#__PURE__*/_jsx(StorefrontCollectionCard, {
              description: ((_collection$published = collection.publishedListing) === null || _collection$published === void 0 ? void 0 : _collection$published.metaDescription) || '',
              imageSrc: "",
              name: ((_collection$published2 = collection.publishedListing) === null || _collection$published2 === void 0 ? void 0 : _collection$published2.name) || collection.internalName,
              slug: ((_collection$published3 = collection.publishedListing) === null || _collection$published3 === void 0 ? void 0 : _collection$published3.slug) || '',
              use: "on-dark"
            }, collection.internalName);
          })
        })
      }), needsPagination && /*#__PURE__*/_jsx(StorefrontPaginator, {
        currentPage: currentPage,
        pageCount: pageCount,
        onPageChange: handlePageChange
      })]
    })
  });
}